<template>
	<div class="small-12 addForm addRent animated fadeInRight border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
		<div class="small-12 columns panelMenuWrapper">
			<div class="small-12 formTitle border-bottom">
				<h2 class="small-12 flex vertical-align justify-between">
					<span class="float-left small-8">
						Create Rent Term
					</span>
					<i class="material-icons-outlined transition" @click="closeMenu()">cancel</i>
				</h2>
				<div class="small-12">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p>
								<b>For: </b>
								{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}
							</p>
						</li>
					</ul>
				</div>	
			</div>
			<div class="small-12 formBody" v-if="property && lease">
				<div class="small-12 image borderRadius8 border light">
					<picture class="flex small-12 justify-center vertical-align">
						<img width="139" :src="vector_image" alt="A lease crawling out of the browser.">
					</picture>
				</div>
				<div class="small-12 sectionTitle flex first">
					<h2>Type</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Rent Term Type<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options">
						<select name="rent_cycle" class="small-12" v-model="new_rent.attributes.term" @change="validateAllFields()">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.statuses" :key="typeOptionIndex" :selected="new_rent.attributes.term == typeOption.value ? true : false">{{typeOption.title}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="rent_term_type.error">
						<small class="cRed small-12">{{rent_term_type.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Rent Term</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Beginning On<em class="cRed">*</em></label>
					<div class="small-12" @click="setCalendarPickerIndex($event)">
						<datetime v-model="new_rent.attributes.term_dates.starting_at" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="calculateCharges($event)"></datetime>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="starting_at.error">
						<small class="cRed small-12">{{starting_at.title}}</small>
					</div>
					<label class="small-12">Ending On<em class="cRed">*</em></label>
					<div class="small-12" @click="setCalendarPickerIndex($event)">
						<datetime v-model="new_rent.attributes.term_dates.ending_at" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="calculateCharges($event)"></datetime>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="ending_at.error">
						<small class="cRed small-12">{{ending_at.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Amount</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Amount (USD)<em class="cRed">*</em></label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition" type="number" step="0.01" name="rent_amount" placeholder="0.00" v-model="new_rent.attributes.amount" @input="calculateEstimatedFees()">
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="amount.error">
						<small class="cRed small-12">{{amount.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Rent Policy</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Rent Cycle<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options">
						<select name="rent_cycle" class="small-12" v-model="new_rent.attributes.policy.cycle" @change="calculateCharges($event)">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.rent_cycles" :key="typeOptionIndex" :selected="new_rent.attributes.policy.cycle == typeOption.value ? true : false">{{typeOption.title}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="cycle.error">
						<small class="cRed small-12">{{cycle.title}}</small>
					</div>
					<div class="small-12 flex">
						<div class="small-12 large-6 columns" style="padding-left:0;">
							<label class="small-12">Due On The<em class="cRed">*</em></label>
							<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options">
								<select name="rent_cycle" class="small-12" v-model="new_rent.attributes.policy.due_on" @change="populateDueOn($event)">
									<option :value="null" selected disabled>Please Choose...</option>
									<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.due_on" :key="typeOptionIndex" :selected="new_rent.attributes.policy.due_on == typeOption.value ? true : false">{{typeOption.title}}</option>
								</select>
							</div>
							<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="due_on_error.error">
								<small class="cRed small-12">{{due_on_error.title}}</small>
							</div>
						</div>
						<div class="small-12 large-6 columns" style="padding-right:0;">
							<label class="small-12">Late By The</label>
							<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options">
								<select name="rent_cycle" class="small-12" v-model="new_rent.attributes.policy.late_by" @change="enableSubmitButtonCheck()">
									<option :value="null" selected disabled>Please Choose...</option>
									<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.due_on" :key="typeOptionIndex" :selected="new_rent.attributes.policy.late_by == typeOption.value ? true : false">{{typeOption.title}}</option>
								</select>
							</div>
							<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="late_by_error.error">
								<small class="cRed small-12">{{late_by_error.title}}</small>
							</div>
						</div>
					</div>
					<label class="small-12">Post (number of days in advance)</label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options">
						<select name="rent_cycle" class="small-12" v-model="new_rent.attributes.due_notification.days_in_advance" @change="enableSubmitButtonCheck()">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="option" v-for="(option, index) in 30" :key="index" :selected="new_rent.attributes.due_notification.days_in_advance == option ? true : false">{{option}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="post_days_error.error">
						<small class="cRed small-12">{{post_days_error.title}}</small>
					</div>
					<label class="small-12">Late Fee (USD)</label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition" type="number" step="0.01" name="late_fee" placeholder="0.00" @keyup="validateAllFields()" v-model="new_rent.attributes.policy.late_fee">
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="late_fee_error.error">
						<small class="cRed small-12">{{late_fee_error.title}}</small>
					</div>
					<label class="small-12">Failed Payment Fee (USD)</label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition" type="number" step="0.01" name="failed_payment_fee" placeholder="0.00" @keyup="validateAllFields()" v-model="new_rent.attributes.policy.failed_payment_fee">
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="failed_payment_fee_error.error">
						<small class="cRed small-12">{{failed_payment_fee_error.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex" v-if="payment_method_set">
					<h2>Transaction Fees</h2>
				</div>
				<div class="small-12 rentFeesBreakdown border borderRadius4 light" v-if="payment_method_set">
					<h2 class="small-12 border-bottom">The below fees are estimates only. Once a resident has made a payment, the actual fees will be available on the invoice.</h2>
					<div class="small-12 columns">
						<p class="small-12 flex vertical-align" v-if="company.attributes.settings.payment_methods.cards">
							<b class="small-8 text-right">Stripe Card Fee:</b> 
							<span class="small-4 text-right" v-if="new_rent.attributes.amount">${{transaction_fees.stripe.card | convertCentsToDollars}}</span>
							<span class="small-4 text-right" v-else>$0</span>
						</p>
						<p class="small-12 flex vertical-align" v-if="company.attributes.settings.payment_methods.ach">
							<b class="small-8 text-right">Stripe ACH Fee:</b> 
							<span class="small-4 text-right" v-if="new_rent.attributes.amount">${{transaction_fees.stripe.ach | convertCentsToDollars}}</span>
							<span class="small-4 text-right" v-else>$0</span>
						</p>
						<p class="small-12 flex vertical-align">
							<b class="small-8 text-right">Nestd Fee:</b> 
							<span class="small-4 text-right" v-if="new_rent.attributes.amount">${{transaction_fees.platform | convertCentsToDollars}}</span>
							<span class="small-4 text-right" v-else>$0</span>
						</p>
						<div class="small-12 totals border-top">
							<p class="small-12 flex vertical-align total" v-if="company.attributes.settings.payment_methods.cards">
								<b class="small-8 text-right">Total for Card Payment:</b> 
								<span class="small-4 text-right" v-if="new_rent.attributes.amount">${{transaction_fees.stripe.card + transaction_fees.platform | convertCentsToDollars}}</span>
								<span class="small-4 text-right" v-else>$0</span>
							</p>
							<p class="small-12 flex vertical-align total" v-if="company.attributes.settings.payment_methods.ach">
								<b class="small-8 text-right">Total for ACH Payment:</b> 
								<span class="small-4 text-right" v-if="new_rent.attributes.amount">${{transaction_fees.stripe.ach + transaction_fees.platform | convertCentsToDollars}}</span>
								<span class="small-4 text-right" v-else>$0</span>
							</p>
						</div>
					</div>
				</div>
				<fieldset class="small-12 flex inputGroup" v-if="payment_method_set">
					<div class="small-12 flex" style="margin-bottom:16px;">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="new_rent.attributes.transaction_fees_policy.set_policy" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Set Transaction Fees Policy</b></p>
							<span class="small-12 columns">Would you like to set an electronic payments transaction fee policy?</span>
						</div>
					</div>
					<div class="small-12 prorated animated fadeIn" v-if="new_rent.attributes.transaction_fees_policy.set_policy">
						<label class="small-12">Who's responsible for the fees?</label>
						<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options">
							<select name="rent_cycle" class="small-12" v-model="new_rent.attributes.transaction_fees_policy.method_type" @change="chooseTransactionFeeMethod($event)">
								<option :value="null" selected disabled>Please Choose...</option>
								<option :value="option.value" v-for="(option, index) in rent_options.transaction_fees_options" :key="index" :selected="new_rent.attributes.transaction_fees_policy.method_type == option.value ? true : false">{{option.title}}</option>
							</select>
						</div>
						<div class="small-12" v-if="show_transaction_fee_amount">
							<label class="small-12">Transaction Fee Amount<em class="cRed">*</em></label>
							<div class="small-12 addOnContainer borderRadius8">
								<input class="inputAddition" type="number" step="0.01" name="custom_transaction_fee_amount" v-model="new_rent.attributes.transaction_fees_policy.resident.fee_amount" @input="calculateEstimatedFees()">
								<div class="add-on borderRadius8">
									<i class="material-icons-outlined">attach_money</i>
								</div>
							</div>
							<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="transaction_fee_error.error">
								<small class="cRed small-12">{{transaction_fee_error.title}}</small>
							</div>
						</div>
						<div class="small-12 responsibilityDescription">
							<h6 class="small-12">Please Note:</h6>
							<p class="small-12 flex" v-if="new_rent.attributes.transaction_fees_policy.method_type == 'owner'">
								<span class="round bgPrimaryBlue small-2"></span>
								<span class="small-10">
									The property owner is fully responsible for the transaction fees 
									and the fees will be deducted from the total rent amount.
								</span>
							</p>
							<p class="small-12 flex" style="margin-bottom:10px;" v-if="new_rent.attributes.transaction_fees_policy.method_type == 'resident'">
								<span class="round bgPrimaryBlue small-2"></span>
								<span class="small-10">
									The resident is partially responsible for the transaction fees and will be 
									charged a separate line item on each invoice of the rent term for the transaction 
									fee amount above.
								</span>
							</p>
							<p class="small-12 flex" v-if="new_rent.attributes.transaction_fees_policy.method_type == 'resident'">
								<span class="round bgPrimaryBlue small-2"></span>
								<span class="small-10">
									If a remainder exists after the deduction of the custom coverage 
									amount above, the remainder of the total fee amount will be the 
									responsibility of the property owner and will be taken from the 
									total amount of the rent.
								</span>
							</p>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Proration</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12 flex" style="margin-bottom:16px;">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="new_rent.attributes.first_month.prorated" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Prorate First Month</b></p>
							<span class="small-12 columns">Would you like to prorate the first month?</span>
						</div>
					</div>
					<div class="small-12 prorated animated fadeIn" v-if="new_rent.attributes.first_month.prorated">
						<label class="small-12">First Month's Rent<em class="cRed">*</em> ({{proratedDays}} Days)</label>
						<div class="small-12 addOnContainer borderRadius8">
							<input class="readOnly inputAddition" type="number" step="0.01" name="prorated_rent_amount" disabled v-model="new_rent.attributes.first_month.charge_amount">
							<div class="add-on borderRadius8">
								<i class="material-icons-outlined">attach_money</i>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
		<div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton borderRadius4 flex justify-center vertical-align" @click="createTheRentTerm()" v-if="enableUpdateButton">
				<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
				Create Rent Term
			</a>
			<a class="disabledButton borderRadius4 flex justify-center vertical-align" v-else>
				<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
				Create Rent Term
			</a>
		</div>
	</div>
</template>

<script>

	// Import the services
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the filters
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'

	// Import the events
	import { GetRentOptions } from '@/events/config/GetRentOptions'
	import { CreateRentTerm } from '@/events/rent/CreateRentTerm'

	// Import the repositories
	import { RentRepository } from '@/repositories/rent/RentRepository'

	// Import the components
	import { Datetime } from 'vue-datetime'

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'AddRentMenu',

		/*
		**  Register the components
		*/

		components: {

			datetime: Datetime

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			AbbreviateNumbersFilters,
			MoneyConversions,
			GetRentOptions,
			RentRepository,
			CreateRentTerm

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
			},

			property: {
				type: Object,
				default: () => null
			},

			lease: {
				type: Object,
				default: () => null
			},

			resident: {
				type: Object,
				default: () => null
			},

			unit: {
				type: Object,
				default: () => null
			},

			user: {
				type: Object,
				default: () => null
			},

			company: {
				type: Object,
				default: () => null
			},

			rents: {
				type: Array,
				default: []
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			vector_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fhouse-credit-card.svg?alt=media&token=68ec7af3-09bc-414f-b1ee-28f5e4da6b58',
			open_menu: false,
			processing: false,
			proratedDays: 0,
			due_on: null,
			property_clone: null,
			stripe_price_response: null,
			future_item: false,
			show_transaction_fee_amount: false,
			transaction_fees: {
				stripe: {
					card: 0,
					ach: 0
				},
				platform: 0
			},
			isBetweenStart: false,
			isBetweenEnd: false,
			payment_method_set: false,
			enableUpdateButton: false,
			rent_term_type: {
				error: false,
				title: null
			},
			starting_at: {
				error: false,
				title: null
			},
			ending_at: {
				error: false,
				title: null
			},
			amount: {
				error: false,
				title: null
			},
			cycle: {
				error: false,
				title: null
			},
			due_on_error: {
				error: false,
				title: null
			},
			late_by_error: {
				error: false,
				title: null
			},
			post_days_error: {
				error: false,
				title: null
			},
			late_fee_error: {
				error: false,
				title: null
			},
			failed_payment_fee_error: {
				error: false,
				title: null
			},
			transaction_fee_error: {
				error: false,
				title: null
			}

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.openTheMenu();

				}

			},

			property: {

				immediate: true, // Load on created
				handler(property) {

					/*
					**  Bind to the property
					**  @method: @here
					*/

					if (property) this.bindToTheProperty();

				}

			},

			company: {

				immediate: true, // Load on created
				handler(company) {

					/*
					**  Check if payment methods have been set
					**  @prop: @here
					*/

					if (company) this.checkPaymentMethods();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

			/*
			**  Get the rent config options
			**  @event: Events/Config/GetRentOptions
			*/

        	this.getRentOptionsHandler();
	
        },

        /*
		**  Set up the methods
		*/

		methods: {

			setDateTimeZIndex: function() {

				$('.panelMenuWrapper').addClass();

			},

			openTheMenu: function() {

				try {

					/*
					**  Display the menu
					**  @prop: @here
					*/

					this.open_menu = true;
					
					/*
					**  Hide the custom transaction fees amount
					**  @prop: @here
					*/

					this.show_transaction_fee_amount = false;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Open the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'U9yI7JqFmXlhBKK4eaea',
                        error: e
                    });

				}

			},

			bindToTheProperty: function() {

				/*
				**  Bind to the property
				**  @prop: @here
				**  @service: @VueFire
				*/

				try {

					this.$bind('property_clone', propertiesModel.doc(this.property.id));

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Bind to the Property Clone Prop in the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'z27g9xEb9gGB3P92kols',
                        error: e
                    });

				}

			},

			checkPaymentMethods: function() {

				/*
				**  Check if payment methods have been set
				**  @prop: @here
				*/

				try {

					if (this.company.attributes.settings.payment_methods.cards || this.company.attributes.settings.payment_methods.ach) this.payment_method_set = true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Check if payment methods have been set in the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'aumKH5ozatKQCKOU0ofU',
                        error: e
                    });

				}

			},

			chooseTransactionFeeMethod: function(event) {

				try {
 
					/*
                    **  Reset the fields
                    **  @props: @here
                    */

					this.show_transaction_fee_amount = false;
					this.new_rent.attributes.transaction_fees_policy.resident = {
						fee_amount: 0,
						percentage: 0
					};
 
					/*
                    **  If resident pays a custom amount
                    **  @props: @here
                    */

					if (event.target.value == 'resident') {

						/*
						**  Set the prop
						**  @props: @here
						*/

						this.show_transaction_fee_amount = true;

						/*
						**  Validate all fields
						**  @method: @here
						*/

						this.validateAllFields();

					} 

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Choose Transaction Fee Method in the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: '0b5B8IgAKBGF57UV0KOp',
                        error: e
                    });

				}

			},

			calculateEstimatedFees: function() {

				try {
 
					/*
                    **  Calculate difference between transaction fee and total amount
                    */

					let newAmount = (Number(this.new_rent.attributes.transaction_fees_policy.resident.fee_amount) + Number(this.new_rent.attributes.amount)) * 100;
 
					/*
                    **  Calculate the Stripe card fees
					*/

					let stripeCardPercent = Number(process.env.VUE_APP_STRIPE_CARD_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
						stripeCardCents = Number(process.env.VUE_APP_STRIPE_CARD_FEE_CENTS) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
					 
					/*
                    **  Calculate the Stripe ACH fees
					*/

					let stripeACHPercent =  Number(process.env.VUE_APP_STRIPE_ACH_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
						stripeACHCents = Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
 
					/*
                    **  Set the props
					**  @props: @here
					*/

					this.transaction_fees.stripe.card = (newAmount * stripeCardPercent) + stripeCardCents;
					this.transaction_fees.stripe.ach = (newAmount * stripeACHPercent) + stripeACHCents;
					this.transaction_fees.platform = newAmount * process.env.VUE_APP_PLATFORM_FEE_PERCENT;

					/*
					**  Validate all fields
					**  @method: @here
					*/

					this.validateAllFields();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Calculate the Estimated Fees in the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'CvzRNCk1D15ezQwmgQZ9',
                        error: e
                    });

				}

			},

			closeMenu: function() {

				try {
 
					/*
                    **  Close the menu
					**  @prop: @here
					*/

					this.open_menu = false;

					/*
                    **  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeAddRentMenu', true);

					/*
                    **  Reset the validation props
					**  @method: @here
					*/

					this.resetValidationProps();

					/*
                    **  Reset the prop
					**  @method: @here
					*/

					this.resetNewRentProp();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'uPraSg96tnosItpr30hP',
                        error: e
                    });

				}

			},

			transactionFeeValidation: function() {

				try {

					if (this.new_rent.attributes.transaction_fees_policy.set_policy && this.new_rent.attributes.transaction_fees_policy.resident.fee_amount != 0 && this.new_rent.attributes.transaction_fees_policy.resident.fee_amount < .01) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.transaction_fee_error.title = 'Your rent term transaction fee must be larger than 1 cent.';
						this.transaction_fee_error.error = true;

					} else if (this.new_rent.attributes.transaction_fees_policy.set_policy && this.new_rent.attributes.transaction_fees_policy.resident.fee_amount.length == 0 || this.new_rent.attributes.transaction_fees_policy.set_policy && this.new_rent.attributes.transaction_fees_policy.resident.fee_amount == '') {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.transaction_fee_error.title = 'This field is required.';
						this.transaction_fee_error.error = true;

					} else {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.transaction_fee_error.title = null;
						this.transaction_fee_error.error = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term transaction fee field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: 'uLu55Y3Q6QoRcyqTcPLQ',
						error: e
					});

				}

			},

			populateDueOn: function() {

				try {

					/*
                    **  Loop through and set the due on title
					**  @prop: @here
					*/

					this.rent_options.due_on.forEach(option => {

						if (option.value == this.new_rent.attributes.policy.due_on) this.due_on = option.title;

					});

					/*
					**  Validate all fields
					**  @method: @here
					*/

					this.validateAllFields();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Populate the Due On the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'vfyUGwkHEsE9TpydGDG0',
                        error: e
                    });

				}

			},

			calculateCharges: function(event) {

				try {

					if (event && event.target && event.target.value && event.target.value == 'monthly' && this.new_rent.attributes.term_dates.starting_at && this.new_rent.attributes.term_dates.ending_at) {
 
						/*
						**  Set the vars
						*/

						let startDate = moment(this.new_rent.attributes.term_dates.starting_at),
							endDate = moment(this.new_rent.attributes.term_dates.ending_at);

						/*
						**  Set the total charges
						*/

						this.new_rent.metrics.total_charges =  Math.ceil(endDate.diff(startDate, 'months', true));

						/*
						**  Set the prorated days and totals
						**  @method: @here
						*/

						this.proratedRent;

					} else if (this.new_rent.attributes.policy.cycle && this.new_rent.attributes.term_dates.starting_at && this.new_rent.attributes.term_dates.ending_at) {

						// Set the vars
						let startDate = moment(this.new_rent.attributes.term_dates.starting_at),
							endDate = moment(this.new_rent.attributes.term_dates.ending_at);

						// Set the total charges
						this.new_rent.metrics.total_charges =  Math.ceil(endDate.diff(startDate, 'months', true));

						/*
						**  Set the prorated days and totals
						**  @method: @here
						*/

						this.proratedRent;

					}

					/*
					**  Validate all fields
					**  @method: @here
					*/

					this.validateAllFields();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Calculate the Charges for the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'mjF2X0atGxsdy1SVzNvl',
                        error: e
                    });

				}

			},

			createTheRentTerm: function() {

				/*
				** Validate
				** @method: @here
				*/

				let validated = this.validate();

				if (!validated) {

					/*
					** Show the message
					** @service: @SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Please fill out all required fields before creating a new rent term.', 'error');

					return;

				}

				/*
				** Check if term dates are valid
				** @method: @here
				*/

				let valid_term_dates =  this.validTermDatesCheck();

				if (!valid_term_dates) {

					/*
					** Show the message
					** @service: @SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Please make sure to enter in a valid date for the rent term start and end dates.', 'error');

					return;

				}

				/*
				** End date check
				** @method: @here
				*/

				let end_date_greater_than_beginning_date = this.endDateCheck();

				if (end_date_greater_than_beginning_date) {

					/*
					** Show the message
					** @service: @SweetAlert2
					*/

					this.$swal('Uh Oh!', 'You cannot have a rent term end date fall before the rent term beginning date.', 'error');

					return;

				}

				/*
				** Check if current rent exists
				** @method: @here
				*/

				let current_term_exists = false;

				if (this.rents.length > 0 && this.new_rent.attributes.term == 'current') current_term_exists = this.currentRentCheck();

				if (current_term_exists) {

					/*
					** Show the message
					** @service: @SweetAlert2
					*/

					this.$swal('Uh Oh!', 'You cannot have more than one rent term in a current status.', 'error');

					return;

				}

				/*
				** Check if dates fall in between other terms
				** @method: @here
				*/

				let in_between_check = this.inBetweenCheck();

				if (in_between_check) {

					/*
					** Show the message
					** @service: @SweetAlert2
					*/

					this.$swal('Uh Oh!', 'You cannot have a rent term\'s beginning or ending date fall within another rent term\'s dates.', 'error');

					return;

				}
 
				/*
				** Set the processing prop
				** @prop: @here
				*/

				this.processing = true;

				/*
				** Create rent term
				** @event: Events/Rent/CreateRentTerm
				*/

				this.createRentTermHandler();

			},

			currentRentCheck: function() {

				try {

					/*
                    **  Search listing for a current status
                    */

					let current_rent = this.rents.filter(rent => {

						return rent.attributes.term == 'current';

					});

					/*
                    **  If one exists, set to true
                    */

					if (current_rent.length > 0) return true;

					/*
                    **  Does not pass validation
                    */

					return false;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Current Rent Check for the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'ueg7UxsHZXXxs9OUiNTN',
                        error: e
                    });

				}

			},

			validate: function() {

				try {
 
					/*
                    **  Required fields
                    **  @props: @here
                    */

					if (this.new_rent.attributes.term == null) return false;
					if (this.new_rent.attributes.term_dates.starting_at == null || this.new_rent.attributes.term_dates.starting_at.length == 0) return false;
					if (this.new_rent.attributes.term_dates.ending_at == null || this.new_rent.attributes.term_dates.ending_at.length == 0) return false;
					if (this.new_rent.attributes.amount == 0 || this.new_rent.attributes.amount == null || this.new_rent.attributes.amount == '') return false;
					if (this.new_rent.attributes.transaction_fees_policy.method_type == 'residents' && this.new_rent.attributes.transaction_fees_policy.resident.fee_amount == 0) return false; 
					
					if (this.new_rent.attributes.policy.cycle == null || this.new_rent.attributes.policy.cycle == '') {

						/*
						**  Set the display errors
						**  @method: @here
						*/

						this.validateRentCycle();

						return false;
					}

					if (this.new_rent.attributes.policy.due_on == null || this.new_rent.attributes.policy.due_on == '' || this.new_rent.attributes.policy.due_on == 0) {

						/*
						**  Set the display errors
						**  @method: @here
						*/

						this.validateDueOn();

						return false;

					}

					return true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Validation for the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'bmAbA9cGsq19U10cCb76',
                        error: e
                    });

				}

			},

			validTermDatesCheck: function() {

				try {

					/*
                    **  Set the vars
                    */

					let startDate = moment(this.new_rent.attributes.term_dates.starting_at),
						endDate = moment(this.new_rent.attributes.term_dates.ending_at);

					/*
                    **  Check if valid
                    */

					if (startDate.isValid() && endDate.isValid()) return true;

					/*
                    **  If does not pass, return false
                    */

					return false;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Valid Term Dates Check Validation for the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'PekipGszsS5KXPHJsaem',
                        error: e
                    });

				}

			},

			endDateCheck: function() {

				try {

					/*
                    **  Set the vars
                    */

					let endsAt = moment(this.new_rent.attributes.term_dates.ending_at),
						startsAt = moment(this.new_rent.attributes.term_dates.starting_at),
						difference = endsAt.diff(startsAt, 'days');

					/*
                    **  Check if valid
                    */

					if (difference > 0) return false;

					/*
                    **  It passes
                    */

					return true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'End Date Check Validation for the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: '1JYDsc2nMByN3V9ozh94',
                        error: e
                    });

				}

			},

			inBetweenCheck: function() {

				try {

					/*
                    **  Set the vars
                    */

					let endsAt = moment(this.new_rent.attributes.term_dates.ending_at).format('YYYY-MM-DD'),
						startsAt = moment(this.new_rent.attributes.term_dates.starting_at).format('YYYY-MM-DD'),
						isBetweenStartForward = false,
						isBetweenEndForward = false,
						isBetweenStartReverse = false,
						isBetweenEndReverse = false;

					/*
                    **  Check if other rent terms dates fall within
                    */

					if (this.rents.length > 0) {

						this.rents.forEach(rent_term => {

							// Set the vars
							let startingAt = moment(rent_term.attributes.term_dates.starting_at * 1000).format('YYYY-MM-DD'),
								endingAt = moment(rent_term.attributes.term_dates.ending_at * 1000).format('YYYY-MM-DD');
								
							isBetweenStartForward = moment(startsAt).isBetween(startingAt, endingAt);
							isBetweenEndForward = moment(endsAt).isBetween(startingAt, endingAt);
							isBetweenStartReverse = moment(startingAt).isBetween(startsAt, endsAt);
							isBetweenEndReverse = moment(endingAt).isBetween(startsAt, endsAt);

						});

					}
 
					/*
                    **  If dates fall between, does not pass
                    */

					if (isBetweenStartForward || isBetweenEndForward || isBetweenStartReverse || isBetweenEndReverse) return true;

					/*
                    **  Passes validation
                    */

					return false;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'In Between Check Validation for the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'MA9RHF788rHZB4htp0Bd',
                        error: e
                    });

				}

			},

			resetValidationProps: function() {

				try {

					/*
					**  Reset the validation props
					**  @props: @here
					*/

					this.rent_term_type.error = false;
					this.rent_term_type.title = null;
					this.starting_at.error = false;
					this.starting_at.title = null;
					this.ending_at.error = false;
					this.ending_at.title = null;
					this.amount.error = false;
					this.amount.title = null;
					this.cycle.error = false;
					this.cycle.title = null;
					this.due_on_error.error = false;
					this.due_on_error.title = null;
					this.late_by_error.error = false;
					this.late_by_error.title = null;
					this.post_days_error.error = false;
					this.post_days_error.title = null;
					this.late_fee_error.error = false;
					this.late_fee_error.title = null;
					this.failed_payment_fee_error.error = false;
					this.failed_payment_fee_error.title = null;
					this.transaction_fee_error.error = false;
					this.transaction_fee_error.title = null;

					/*
					**  Disable the submit button
					**  @prop: @here
					*/

					this.enableUpdateButton = false;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Reset the Validation Props for the Add Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Add Rent',
						uid: '2qc7GH1NBpAbsnBlXiqL',
                        error: e
                    });

				}

			},

			termTypeValidation: function() {

				try {

					let current_rent = [];

					if (this.rents && this.rents.length > 0) {

						/*
						**  Search listing for a current status
						*/

						current_rent = this.rents.filter(rent => {

							return rent.attributes.term == 'current';

						});

					}

					if (!this.new_rent.attributes.term) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.rent_term_type.title = 'This field is required.';
						this.rent_term_type.error = true;

				   	} else if (current_rent.length > 0 && this.new_rent.attributes.term == 'current') {

						   	/*
							**  Set the error props
							**  @props: @here
							*/

							this.rent_term_type.title = 'You cannot have more than one rent term in a current status.';
							this.rent_term_type.error = true;

					} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.rent_term_type.title = null;
						this.rent_term_type.error = false;

				   	}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term type field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: 'mhdpouZCs9oRfivurNma',
						error: e
					});

				}

			},

			enableSubmitButtonCheck: function() {

				try {

					/*
					**  Validate the all fields
					**  @method: @here
					*/

					if (!this.rent_term_type.error && !this.starting_at.error && !this.ending_at.error && !this.amount.error && !this.cycle.error && !this.due_on_error.error && !this.late_by_error.error && !this.post_days_error.error && !this.failed_payment_fee_error.error && !this.transaction_fee_error.error && !this.late_fee_error.error) {

						/*
						**  Enable the submit button
						**  @prop: @here
						*/

						this.enableUpdateButton = true;

					} else {

						/*
						**  Disable the submit button
						**  @prop: @here
						*/

						this.enableUpdateButton = false;

					}

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Enable Submit Button Check for the Add Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Add Rent',
						uid: 'r9Wyz6Wyu2zd2Jidd7I2',
                        error: e
                    });

				}	

			},

			validateDueOn: function() {

				try {

					if (!this.new_rent.attributes.policy.due_on || this.new_rent.attributes.policy.due_on == null || this.new_rent.attributes.policy.due_on == '' || this.new_rent.attributes.policy.due_on == 0) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.due_on_error.title = 'This field is required.';
						this.due_on_error.error = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.due_on_error.title = null;
						this.due_on_error.error = false;

				   	}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent cycle field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: 'z289ePZQHuWeRIE7MERn',
						error: e
					});

				}

			},

			validateRentCycle: function() {

				try {

					if (!this.new_rent.attributes.policy.cycle || this.new_rent.attributes.policy.cycle == null || this.new_rent.attributes.policy.cycle == '') {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.cycle.title = 'This field is required.';
						this.cycle.error = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.cycle.title = null;
						this.cycle.error = false;

				   	}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent cycle field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: 'z289ePZQHuWeRIE7MERn',
						error: e
					});

				}

			},

			termDatesValidation: function() {

				try {

					/*
                    **  Set the vars
                    */

					let endsAt = moment(this.new_rent.attributes.term_dates.ending_at).unix(),
						startsAt = moment(this.new_rent.attributes.term_dates.starting_at).unix(),
						difference = moment(this.new_rent.attributes.term_dates.starting_at).diff(moment(this.new_rent.attributes.term_dates.ending_at), 'days'),
						isBetweenStartForward = false,
						isBetweenEndForward = false,
						isBetweenStartReverse = false,
						isBetweenEndReverse = false;

					/*
                    **  Check if other rent terms dates fall within
                    */

					if (this.rents.length > 0) {

						this.rents.forEach(rent_term => {

							// Set the vars
							let startingAt = moment(rent_term.attributes.term_dates.starting_at),
								endingAt = moment(rent_term.attributes.term_dates.ending_at);
		
							isBetweenStartForward = moment(startsAt).isBetween(startingAt, endingAt);
							isBetweenEndForward = moment(endsAt).isBetween(startingAt, endingAt);
							isBetweenStartReverse = moment(startingAt).isBetween(startsAt, endsAt);
							isBetweenEndReverse = moment(endingAt).isBetween(startsAt, endsAt);

						});

					}

					/*
                    **  If dates fall between, does not pass
                    */

					if (!this.new_rent.attributes.term_dates.ending_at || this.new_rent.attributes.term_dates.ending_at == '' || this.new_rent.attributes.term_dates.ending_at == null || !this.new_rent.attributes.term_dates.starting_at || this.new_rent.attributes.term_dates.starting_at == '') {

						if (!this.new_rent.attributes.term_dates.ending_at || this.new_rent.attributes.term_dates.ending_at == '' || this.new_rent.attributes.term_dates.ending_at == null) {

							/*
							**  Set the error props
							**  @props: @here
							*/

							this.ending_at.title = 'This field is required.';
							this.ending_at.error = true;

						} else {

							/*
							**  Set the error props
							**  @props: @here
							*/

							this.ending_at.title = null;
							this.ending_at.error = false;

						}

						if (!this.new_rent.attributes.term_dates.starting_at || this.new_rent.attributes.term_dates.starting_at == '') {

							/*
							**  Set the error props
							**  @props: @here
							*/

							this.starting_at.title = 'This field is required.';
							this.starting_at.error = true;

						} else {

							/*
							**  Set the error props
							**  @props: @here
							*/

							this.starting_at.title = null;
							this.starting_at.error = false;

						}

					} else if (isBetweenEndForward || isBetweenEndReverse) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.ending_at.title = 'You cannot have a rent term\'s ending date fall within another rent term\'s dates.';
						this.ending_at.error = true;

					} else if (isBetweenStartForward || isBetweenStartReverse) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.starting_at.title = 'You cannot have a rent term\'s starting date fall within another rent term\'s dates.';
						this.starting_at.error = true;

					} else if (difference > 0) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.ending_at.title = 'You cannot have a rent term ending date fall before the rent term beginning date.';
						this.ending_at.error = true;

					} else {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.ending_at.title = null;
						this.ending_at.error = false;
						this.starting_at.title = null;
						this.starting_at.error = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term dates fields.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'FIY3Ocg8FSz79MqqhLre',
						error: e
					});

				}

			},

			amountValidation: function() {

				try {

					/*
					**  Check if not null, else check if negative
					*/

				   	if (this.new_rent.attributes.amount == 0 || this.new_rent.attributes.amount == null || this.new_rent.attributes.amount == '') {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.amount.title = 'This field is required.';
						this.amount.error = true;

				   	} else if (this.new_rent.attributes.amount < .01) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.amount.title = 'Your rent amount must be 1 cent or larger.';
						this.amount.error = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.amount.title = null;
						this.amount.error = false;

				   	}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term ending at field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: '26qfJtDAMousSgiA0tW3',
						error: e
					});

				}

			},

			lateFeeValidation: function() {

				try {

					if (this.new_rent.attributes.policy.late_fee != 0 && this.new_rent.attributes.policy.late_fee < .01 || this.new_rent.attributes.policy.late_fee == null) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.late_fee_error.title = 'Your rent term late fee must be 1 cent or larger.';
						this.late_fee_error.error = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.late_fee_error.title = null;
						this.late_fee_error.error = false;

				   	}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term late fee field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: '8t8p5Oupr5KddYPVf3Jm',
						error: e
					});

				}

			},

			failedPaymentFeeValidation: function() {

				try {

					if (this.new_rent.attributes.policy.failed_payment_fee != 0 && this.new_rent.attributes.policy.failed_payment_fee < .01) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.failed_payment_fee_error.title = 'Your term failed payment fee must be 1 cent or larger.';
						this.failed_payment_fee_error.error = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.failed_payment_fee_error.title = null;
						this.failed_payment_fee_error.error = false;

				   	}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term failed payment fee field.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: '8tdLhzXu7ivUOINeppRh',
						error: e
					});

				}

			},

			validateAllFields: function() {

				try {

					/*
					**  Term type validation
					**  @method: @here
					*/

					this.termTypeValidation();

					/*
					**  Due on validation
					**  @method: @here
					*/

					this.validateDueOn();

					/*
					**  Rent cycle validation
					**  @method: @here
					*/

					this.validateRentCycle();

					/*
					**  Term dates validation
					**  @method: @here
					*/

					this.termDatesValidation();

					/*
					**  Amount validation
					**  @method: @here
					*/

					this.amountValidation();

					/*
					**  Late fee validation
					**  @method: @here
					*/

					this.lateFeeValidation();

					/*
					**  Failed payment fee validation
					**  @method: @here
					*/

					this.failedPaymentFeeValidation();

					/*
					**  Transaction fee validation
					**  @method: @here
					*/

					if (this.new_rent.attributes.transaction_fees_policy.set_policy && this.new_rent.attributes.transaction_fees_policy.method_type == 'resident') {

						this.transactionFeeValidation();

					}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate all fields of the form.',
						errorType: 'Application',
						section: 'Add Rent',
						uid: 'vzThKNU0gcnTOQetFv0w',
						error: e
					});

				}

			},

			setCalendarPickerIndex: function(event) {

                try {

                    /*
					**  Emit the event
					**  @service: @Vue
					*/

                    this.$emit('setCalendarPickerIndex', true);
                    
                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the set calendar picker index event.',
						errorType: 'Application',
						section: 'Add Rent Menu',
						uid: 'WAM47DzXNJmqaBVoecMp',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			proratedRent: function() {

				if (!this.processing && moment(this.new_rent.attributes.term_dates.starting_at).isValid()) {

					if (this.new_rent.attributes.amount > 0 && this.new_rent.attributes.term_dates.starting_at) {

						/*
						**  Set the vars
						*/

						let startDate = moment(this.new_rent.attributes.term_dates.starting_at).format('DD'),
							totalDaysInMonth = moment(this.new_rent.attributes.term_dates.starting_at).daysInMonth(),
							daysRemaining = totalDaysInMonth - startDate; 

						/*
						**  Calculate days since lease beginning date
						*/

						let amount = ((this.new_rent.attributes.amount / totalDaysInMonth) * daysRemaining).toFixed(2);
 
						/*
						**  Add to props
						*/

						this.new_rent.attributes.first_month.charge_amount = Number(amount);
						this.proratedDays = daysRemaining;

					} else {

						/*
						**  Add to props
						*/

						this.new_rent.attributes.first_month.charge_amount = 0;
						this.proratedDays = 0;

					}

				}

				/*
				**  Calculate the estimated fees
				**  @method: @here
				*/

				this.calculateEstimatedFees();

				/*
				**  Validate the fields
				**  @method: @here
				*/

				this.validateAllFields();

			},

			formatted_starting_at: function() {

				return 

			}
			
		},

		/*
		**  Set the filters
		*/

		filters: {

			termDate: function(value) {

				if (value) return moment(value).format('MM/DD/YYYY');
				
			}

		}

	}

</script>